// extracted by mini-css-extract-plugin
module.exports = {"modalWrap":"ConfirmModal_modalWrap__1Bhy-","buttonWrap":"ConfirmModal_buttonWrap__2i2X4"};